<template>
  <router-link :to="'portfolio/detail/'+ id">
    <div class="card_bg ani_up">
      <img class="main_image" :src="image" />
      <div class="card_content">
        <div
          style="
            font-weight: 700;
            color: black;
            display: block;
            font-size: 18px;
          "
        >
          {{ text1 }}
        </div>
        <div
          style="
            font-weight: 300;
            color: #868e96;
            display: block;
            font-size: 14px;
          "
        >
          {{ text2 }}
        </div>
        <div
          style="
            height: 70px;
            font-weight: 300;
            color: #495057;
            font-size: 14px;
          "
        >
          <div v-html="formattedText3"></div>
        </div>
      </div>
    </div>
  </router-link>
</template>
    
    <script>
export default {
  props: ["record", "id", "image", "text1", "text2", "text3", "link"],
  data() {
    return {};
  },
  computed: {
    formattedText3: function () {
      return this.text3.replace(/\n/g, "<br>");
    },
  },
};
</script>
    
  <style scoped>
.bg {
  display: flex;
  justify-content: center;
  text-align: center;
}
.caption {
  width: fit-content;
  position: relative;
  padding-left: 10px;
  padding-right: 10px;
}
.card_bg {
  padding: 0px;
  text-align: left;
  width: 352px;
  height: 349px;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  overflow: hidden;
}

.card_content {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 20px;
  margin-bottom: 40px;
  overflow: hidden;
}

.main_image {
  width: 100%;
  height: 190px;
  object-fit: cover;
  border-top-left-radius: 16px;
}

@media screen and (max-width: 1440px) {
  .card_bg {
    padding: 0px;
    text-align: left;
    width: 90vw;
    height: 349px;
    background: #ffffff;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
    border-radius: 16px;
    overflow: hidden;
  }

}
</style>